(function (upp) {
    'use strict';

    //Directive to show the breadcrumb
    upp.directive('aboutNavBarTpl', [function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                modules: '='
            },
            controller: ['$location', '$scope', function ($location, $scope) {
                $scope.onTabChange = function () {
                    $location.path($scope.actualTab);
                };
            }],
            template: '' +
            '<div class="about-navbar-responsive">' +
            '   <ul class="nav nav-pills nav-tabs-responsive">' +
            '       <li data-ng-repeat="tab in modules" class="nav-opt" data-ng-class="{\'active\': tab.active}">' +
            '           <a data-ng-href="#!{{ tab.url }}" class="nav-opt-link nav-about-tab-{{ tab.type }}">' +
            '               <span data-ng-class="enabled">{{ tab.name }}</span>' +
            '           </a>' +
            '       </li>' +
            '   </ul>' +
            '   ' +
            '   <div class="nav-tabs-responsive-select-wrapper">' +
            '       <select class="nav-tabs-responsive" ng-model="actualTab" data-ng-change="onTabChange()" text-color="primary" font-family>' +
            '           <option data-ng-repeat="tab in modules"  value="{{ tab.url }}" ng-selected="{{ tab.active }}" text-color="primary" font-family>' +
            '               {{ tab.name }}' +
            '           </option>' +
            '       </select>' +
            '   </div>' +
            '</div>'
        };
    }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/about/directives/about-nav_bar-directive.js